import React, { useEffect } from "react";
import PageWrapper from "../../lib/page-wrapper";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import get from "lodash/get";
import { getCampaignsForUser } from "../../../action_managers/campaigns";
import { StyledTable, TwoLineTableRow } from "../../lib/tables/styled-table";
import { If } from "react-extras";
import moment from "moment";
import Spinner from "../../lib/spinner";
const columnInfo = props => [
  {
    accessor: "name",
    Cell: function Cell({ original: campaign }) {
      let subtitle = "Created";
      if (campaign.state !== "created") {
        subtitle = `Start Date: ${moment.unix(campaign.startsAt).format("LL")}`;
      }
      return (
        <TwoLineTableRow
          onClick={() => props.history.push(`/campaigns/${campaign.uuid}`)}
          title={campaign.name}
          subtitle={subtitle}
        />
      );
    },
  },
];

const useSelectUser = () => useSelector(state => state.user.user);
const useSelectUserCampaigns = () =>
  useSelector(state =>
    get(state, "campaigns.campaignsForUser", []).map(uuid => state.campaigns.campaigns[uuid])
  );
const CampaignListPage = props => {
  const dispatch = useDispatch();
  const user = useSelectUser();
  const userUUID = user?.uuid;
  useEffect(() => {
    if (userUUID) {
      dispatch(getCampaignsForUser(userUUID));
    }
  }, [userUUID, dispatch]);
  const campaigns = useSelectUserCampaigns();

  return (
    <PageWrapper
      title={"Campaigns"}
      topRightElement={() => (
        <If condition={!!campaigns.length}>
          <Link className="bold" to={"/campaigns/new"}>
            New Campaign
          </Link>
        </If>
      )}>
      <Grid fluid>
        <If condition={!props.isLoading}>
          <>
            <If condition={!campaigns.length}>
              <Row>
                <Col xs={12} md={6} mdOffset={3} className={"text-center"}>
                  <p className={"margin-top--large"}>
                    Create a campaign and invite relevant podcasts to run your promotion on their
                    shows.
                  </p>
                </Col>
                <Col xs={12} md={4} mdOffset={4}>
                  <button
                    className="btn btn-primary width-100 margin-top--large"
                    onClick={() => {
                      props.history.push("/campaigns/new");
                    }}>
                    New Campaign
                  </button>
                </Col>
              </Row>
            </If>
            <If condition={!!campaigns.length}>
              <StyledTable data={campaigns} columns={columnInfo(props)} />
            </If>
          </>
        </If>
        <If condition={!!props.isLoading}>
          <Spinner isLoading={props.isLoading} />
        </If>
      </Grid>
    </PageWrapper>
  );
};
export default withRouter(
  connect(
    state => ({
      user: state.user.user,
      isLoading: state.campaigns.campaignsForUserIsLoading,
    }),
    {
      getCampaignsForUser,
    }
  )(CampaignListPage)
);
